<template>
  <Menu class="top-nav" :class="[thema=='blue'?'pc3_blue-header':'']" mode="horizontal" theme="dark" :active-name="activeName" @on-select="go" ref="pc3top_nav">
    <div class="top-menu nav__left" ref="navRight" :class="{'pc3blue_nav__left':thema == 'blue'}">
      <div class="site-title fx-line3" :style="{ background: `url(${this.$store.state.core.logoUrl}) no-repeat left center` }">
        <!-- <span class="system_name" :style="thema == 'blue' ? 'color:#445974' : ''">{{title}}</span> -->
        <span class="system_name" :style="thema == 'blue' ? 'color:#FFF' : ''">{{title}}</span>
      </div>
    </div>
    <div class="nav__right">
      <div class="pc3_top_menus">
        <template v-for="(item, index) in navs">
          <!-- 只有一级菜单 -->
          <template v-if="item.children==undefined">
            <MenuItem :name="item.name" :key="item.menukey" class="menu_item" :class="{'pc3blue_menu_item':thema == 'blue'}">
            <!-- <i v-if='item.icon' :class="item.icon"></i> -->
            <i :class="(item.icon === undefined || item.icon == 'undefined') ? 'fa fa-ravelry ' : item.icon " class="fa-lg"></i>
            <span class="item_text">{{item.text}}</span>
            </MenuItem>
          </template>
          <!-- 有多级菜单 -->
          <template v-else>
            <div :key="index" style="padding: 0 14px;margin-left: 20px;white-space: nowrap;cursor: pointer;" :style="{'color':thema == 'blue' ? '':'#c4c6cf'}" :class="['fx__item_ico',selMmenusKey==item.menukey?(thema == 'blue'?'pc3blue_menu_item-select':'fx-color-brand'):'',thema == 'blue'?'pc3blue_menu_item':'' ]" @click="changeSideBar(item)">
              <i :class="(item.icon === undefined || item.icon == 'undefined') ? 'fa fa-ravelry ' : item.icon " class="fa-lg" style="margin-right: 6px;"></i>
              <span class="item_text">{{item.text}}</span>
            </div>
          </template>
        </template>
      </div>
      <!-- 全局搜索框 -->
      <!-- <searchInput class="site-input " style="width: 251px;"></searchInput> -->
      <!-- 铃铛 -->
      <!-- <Remind style="margin-right: 30px" :class="{'fx-line3':thema !== 'blue'}" :style="thema == 'blue' ? 'color:#445974' : ''" v-if="$app.Cfg.notify.moduleChannelDict['app-remind']?true:false" /> -->
      <!-- 账号管理 -->
      <core-userprofile class="pc3_user" :class="{'fx-line3':thema !== 'blue'}" :style="thema == 'blue' ? 'color:#445974' : ''" />
    </div>
  </Menu>
</template>

<script>
import sideBarItem from "./sideBarItem"

export default {
  components: { sideBarItem },
  data() {
    var navs = this.$app.menus
    return {
      selMmenusKey: "", //选中含有子菜单
      navs,
      screenWidth: Number,
      fun: null, //防抖
    }
  },
  watch: {
    screenWidth: function (newVal, oldVal) {
      //监听窗口宽度
      let _this = this
      if (_this.fun) {
        //防抖
        clearTimeout(_this.fun)
      }
      _this.fun = setTimeout(() => {
        if (newVal <= 1243) {
          this.navs = this.newNav
        } else if (newVal > 1243) {
          this.navs = this.$app.menus
        }
      }, 500)
    },
    selMmenusKey: function (newVal, oldVal) {
      console.log(newVal)
      let _this = this
      sessionStorage.setItem("PC3menukey", newVal)
      if (newVal) {
        let menu = this.$app.menus.find((p) => p.menukey == newVal)
        for (let index = 0; index < menu.children.length; index++) {
          if (menu.children[index].children && menu.children[index].children.length > 0) {
            menu.children[index].isfold = true
          }
        }
        this.$nextTick(() => {
          _this.$app.event.emit("changePC3SideBar", menu)
          _this.$refs["pc3top_nav"].currentActiveName = undefined
          _this.$refs["pc3top_nav"].updateActiveName()
        })
      } else {
        _this.$app.event.emit("changePC3SideBar", [])
      }
    },
  },
  mounted() {


    let _this = this
    this.screenWidth = document.body.clientWidth
    this.selMmenusKey = sessionStorage.getItem("PC3menukey") || ""
    // if (this.selMmenusKey) {
    //   let menu = this.$app.menus.find(p => p.menukey == this.selMmenusKey)
    //   _this.$app.event.emit("changePC3SideBar", menu)
    //   this.$nextTick(() => {
    //     _this.$refs["pc3top_nav"].currentActiveName = undefined
    //     _this.$refs["pc3top_nav"].updateActiveName()
    //   })
    // } else {
    //   this.$nextTick(() => {
    //     _this.$app.event.emit("changePC3SideBar", [])
    //   })
    // }
    window.onresize = () => {
      //监听窗口宽度
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  computed: {
    thema() {
      return this.$store.state.core.thema
    },
    // navsWidth: {
    //   get: function() {
    //     let _this = this;
    //     let aa = this.screenWidth;
    //     return aa;
    //   }
    // },
    activeName() {
      return this.$route.name
    },
    title() {
      // return this.$store.state.core.title;
      return this.$app.ProjSetting.title
    },
  },
  methods: {
    go(name) {
      this.$app.routeMenuTo(name)
      this.selMmenusKey = ""
    },
    changeSideBar(menu) {
      let _this = this
      this.selMmenusKey = menu.menukey
    },
  },
}
</script>
<style  lang="scss">
.fx-thema.blue .top-nav.ivu-menu-horizontal .pc3blue_menu_item.ivu-menu-item-active:not(.ivu-menu-submenu) {
  background: #3189ff !important;
}
.top-nav {
  .ivu-select-dropdown {
    padding: 0;
    margin: 0;
  }
  .ivu-menu-drop-list .ivu-menu-item span {
    padding-left: 10px;
  }
  .ivu-menu-drop-list li {
    list-style: none;
  }
  &.ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown {
    max-height: 500px;
  }
}
</style>

<style lang="scss" scoped>
.top-nav {
  background: none;
  width: 100%;
  height: 100%;
  line-height: 38px;
  font-size: 14px;
  z-index: 900;
  display: flex;
  justify-content: space-between;

  .nav__left {
    .menu_item {
      background-color: transparent !important;
      i {
        font-size: 20px;
      }
    }
  }
  .pc3_top_menus {
    display: flex;
    align-items: center;
    padding: 0 16px 0 0;
  }
  .pc3_user {
    margin-left: auto;
  }
  .nav__right {
    display: flex;
    width: calc(100% - 280px);
    align-items: center;
    padding-right: 16px;
    .menu_item {
      margin-left: 20px;
    }
    .site-input {
      margin-right: 35px;
    }
  }
}
.site-title {
  // color: #fff;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  max-width: 400px;
  height: 100%;
  // background: url(/static/img/logo.png) no-repeat left center;
  .system_name {
    padding-left: 50px;
    line-height: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
// 蓝色布局特殊处理
.pc3blue_nav__left {
  background: #39a8fc;
}
.top-menu {
  width: 280px;
  padding-left: 16px;
  // margin: 0 20px;
}
@media screen and (max-width: 1600px) {
}
@media screen and (max-width: 1200px) {
  .top-nav .item_text {
    // display: none;
  }
}
</style>
<style scoped>
.ivu-menu-horizontal ::v-deep .ivu-menu-item {
  padding: 0 14px;
  white-space: nowrap;
}
.ivu-menu-horizontal ::v-deep .ivu-menu-submenu {
  white-space: nowrap;
}
@media screen and (max-width: 1200px) {
  .top-app-header .ivu-menu-horizontal ::v-deep .ivu-menu-submenu {
    padding: 0 6px;
  }
}
.top-app-header .ivu-menu-horizontal ::v-deep .ivu-menu-submenu {
  padding: 0 14px;
}
.pc3blue_menu_item {
  background: #ebf0f4;
  border-radius: 3px;
  color: #535353;
}
.pc3blue_menu_item-select {
  background: #3189ff;
  color: #fff;
}
.pc3blue_menu_item-select:hover {
  color: #fff !important;
}
.pc3_blue-header {
  /* box-shadow: rgba(0, 0, 0, 0.1) 6px 0px 16px; */
  /* background: rgba(226, 237, 251, 1); */
}
</style>